import {useEffect, useState} from "react";
import {useQuery} from "@tanstack/react-query";
import {getSalesTerritories} from "../services/IsfaService";

export function useSalesTerritories(businessUnitCode, salesRegionId, enabled = true, callback = () => {
}) {
    const [salesTerritories, setSalesTerritories] = useState([]);

    const {data, isSuccess} = useQuery({
        queryKey: ["salesTerritories", businessUnitCode, salesRegionId],
        queryFn: () => getSalesTerritories(businessUnitCode, salesRegionId),
        enabled: enabled,
        retry: false,
    });

    useEffect(() => {
        if (data) {
            const newSalesTerritories = data?.sort((a, b) => {
                const numA = parseInt(a.name?.split("-")[1], 10);
                const numB = parseInt(b.name?.split("-")[1], 10);
                return numA - numB;
            })?.map((item) => {
                let displayName = item.name;
                if (!!item.salesRepLastName) {
                    displayName += " (" + item.salesRepLastName + ")";
                }
                return {...item, name: displayName};
            });
            setSalesTerritories(newSalesTerritories);
            callback(newSalesTerritories);
        }
    }, [data]);

    return salesTerritories;
}
